import { useEffect, useState } from 'react';
import { SITE_STATUS } from '../constants/siteStatus';

/** A site is "stalled" when it has been in `publishing` past this threshold. */
export const STALL_THRESHOLD_MS = 5 * 60 * 1000;

/**
 * Returns `true` once a site has been in `publishing` for >5 minutes (typical
 * deploy is ~1.5 min). The badge uses this to drop the pulse animation +
 * switch to a neutral variant, and the retry-publish button uses it to render
 * itself.
 *
 * Polls every 30s while the site is publishing so the threshold can be
 * crossed without a full refetch.
 */
export const useStuckPublishing = (
  site: { status: string; updatedAt?: string } | null | undefined,
): boolean => {
  const [now, setNow] = useState(() => Date.now());
  const isPublishing = site?.status === SITE_STATUS.PUBLISHING;
  useEffect(() => {
    if (!isPublishing) return;
    const t = setInterval(() => setNow(Date.now()), 30 * 1000);
    return () => clearInterval(t);
  }, [isPublishing]);

  if (!isPublishing || !site) return false;
  const updatedAt = site.updatedAt ? new Date(site.updatedAt).getTime() : NaN;
  if (!Number.isFinite(updatedAt)) return false;
  return now - updatedAt >= STALL_THRESHOLD_MS;
};
